


























import { Component, Vue } from 'vue-property-decorator';
import HomeAnonymous from '@/components/HomeAnonymous.vue'; // @ is an alias to /src
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import { globalUC } from '../UserCache'
import { StoryUser, planTypes, tutorialSteps } from '../StoryUser'

@Component({
  name: 'Home',
  components: { HomeAnonymous, 
  StoriesComponent: () => import('@/components/StoriesComponent.vue'),
  ModalWrapperComponent: () => import('@/components/ModalWrapperComponent.vue')
 }
})
export default class HomeView extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get isAuthenticated(): boolean { return this.$store.getters.isAuthenticated }
  public get user(): StoryUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }

  // public functions available to the html template
  public inviteFriend(): void {
    const modalTitle: string = 'Invite to StoryCircle';
    (this.$refs.InviteTypeComponent as any).show(modalTitle, 'md', { invitedByName: this.user.firstName })
  }
  public startStorySelf(): void {
    if (this.user.phoneNumberIds.length > 0) {
      (this.$refs.StoryStartFormModalComponent as any).show('Record a Memory About Yourself', 'lg', { circleUser: this.user, circleId: this.user.circleId, storyTellerId: this.userId })
    } else {
      (this.$refs.PhoneNumberFormModalComponent as any).show('Add Your Phone Number to Enable Recording', 'md', null)
    }
  }
  public poseQuestion(): void {
    (this.$refs.StoryStartFormModalComponent as any).show('Pose a Question to a Storyteller', 'lg', null)
  }
  // this.$emit('changed-modalshow', this.innerComponentName, val, this.payload); // in case parent (navbar) wants to know we open or closed modal along with inner component payload
  public async onModalShowChangeStoryStartForm(componentName: string, showing: boolean, submittedStory: boolean): Promise<void> {
    if (!showing && submittedStory) {
      // tell StoriesComponent to refresh
      await (this.$refs.StoriesComponent as any).refresh()
    }
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async created() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} created()`)

    // store utm parameters into localStorage so that we always know them
    utils.saveUTMsToLocalStorage(this.$route.query)
    
  }  
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    // @ts-ignore: because segment analytics is loaded in head script
    // window.analytics.page(this.$options.name)    // don't do this one because HomeAnonymous and StoriesComponent will do this page view
      
    // @ts-ignore: because segment analytics is loaded in head script
    if (this.user) window.analytics.identify(this.user.getIdAsString(), this.user.getTraitObjectForSegment());

    if (this.$route.params.title && this.$route.params.msg) utils.toast(this, this.$route.params.title, this.$route.params.msg)

    if (this.isAuthenticated) {
      // seems like a convenient time and place to update me - nah, TutorialComponent does this already
      // const user: StoryUser = await globalUC.get(this.$store.getters.userId, true)
      // utils_auth.saveAuthStuffToStoreAndLocalStorage(user, null)

      // pre-cache my connections
      await globalUC.fetchRelated(false);
    }

    // if user has invitations to accept, pop it up; but not if they haven't finished the tutorial
    if (this.user && this.user.getCircle().pendingIncomingFollowers.length > 0 && this.user.tutorialStepsDone.includes('finishingScreen')) (this.$refs.RespondToInvites as any).show(`${this.user.firstName}, You Have Invitations to Join Your Circle`, 'md', null)
  }
}

